import { render } from "./SSOAuthentication.vue?vue&type=template&id=7e30cba4"
import script from "./SSOAuthentication.vue?vue&type=script&lang=js"
export * from "./SSOAuthentication.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__